const api = "https://safedesk.apiexperta.com.ar";
//const api = "http://localhost:3000";
export { api };